const VerifoneIntegrationType = Object.freeze({
    /**
     * P400 or E355 connected by ethernet or WiFi. There is no software on the PC.
     * ProPoint makes 2 socket connections to terminal's IP address - one to the integration port
     * and one to the progress port.
     * See: Ocius Payment Application Solution Integration Specification v2.5 - 11th September 2019.pdf
     * https://drive.google.com/open?id=1jAFPxJPSH5luaRx1kxaaYxKuRw0ik5ws
     */
    ENGAGE: 'ENGAGE',
    /**
     * VX820IP connected by ethernet. There is no software on the PC.
     * ProPoint makes 1 socket connections to terminal's IP address - to the integration port.
     * There is no progress port.
     * See: P2PE eVo Terminals Implementation Guide v2.3 - May 2016.pdf
     * https://drive.google.com/open?id=1cIJtICR2o9ywsAFiH6_ChT27ktPLD3Kh
     */
    EVO: 'EVO',
    /**
     * VX820 connected by USB or serial to the PC. Verifone POS Client software is installed on the PC.
     * ProPoint makes 2 socket connections to POS Client software - one to the integration port
     * and one to the progress port.
     * See: POS Client Integration Guide v2.1 - 15th April 2015.pdf
     * https://drive.google.com/open?id=1gxLs9kgadgzPrRRcKwB-hwNf_nhEyI6I
     */
    POS_CLIENT: 'POS_CLIENT',
});

module.exports = VerifoneIntegrationType;
